module.exports = __webpack_public_path__ + "typicons.95aa28e29618c068e8a5.woff";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/typicons.font/src/font/typicons.woff
// module id = ../../../../typicons.font/src/font/typicons.woff
// module chunks = styles